<template>
  <b-card>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button :to="{ name: 'admin-tree-add'}" variant="primary"
            >Add</b-button
          >
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="d-inline-block mr-1"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Table -->
    <b-table responsive="sm" :items="news" :fields="fields" :busy="isBusy">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
      </template>
      <template #cell(image_url_admin)="news">
        <div class="d-flex justify-content-start" v-if="news.item.image_url_admin !== null">
            <b-img
              thumbnail
              fluid
              rounded
              style="width:100px"
              :src="news.item.image_url_admin"
            >

            </b-img>
        </div>
        <div class="d-flex justify-content-start" v-else>
           -
        </div>
      </template>
      <template #cell(action)="news">
        <div class="d-flex justify-content-start">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon mr-1"
            :to="{ name: 'admin-tree-detail', params: { key: news.item.id } }"
          >
            <feather-icon icon="Edit3Icon" />
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="btn-icon"
            @click="confirmDeleteNews(news.item.id)"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
  },
  data() {
    return {
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'image_url_admin', label: 'Image' },
        { key: 'type', label: 'Type' },
        { key: 'id_parent', label: 'ID Parent' },
        'action'
      ],
      news: [],
      searchWord: '',
    }
  },

  directives: {
    Ripple,
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString().replace(/<[^>]*>?/gm, '');
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  watch: {
    perPage() {
      this.fetchNews()
    },
    currentPage() {
      this.fetchNews()
    },
    searchWord() {
      this.fetchNews()
    },
  },

  mounted() {
    this.fetchNews()
  },

  methods: {
    fetchNews() {
      this.isBusy = true

      this.$http
        .get('/tree-admin', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            s: this.searchWord.toString().trim(),
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.news = data.data
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    changePage(page) {
      this.currentPage = page
    },
    async deleteNews(newsId) {
      this.isBusy = true
      return await this.$http
        .delete(`/tree-admin/delete/${newsId}`)
        .then(res => {
          this.$notif(
            'Success',
            'Tree has been successfully deleted.',
            'success'
          )
        })
        .catch(({ data }) => {
          this.$notif('Something Error', data.message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    confirmDeleteNews(newsId) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteNews(newsId).then(() => {
              this.fetchNews()
            })
          }
        })
    },
    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        if (j === 'date') {
          data = this.$moment(v.created_at).format('D-M-Y')
        }

        if (j === 'cfu') {
          data = v.cfu.name
        }

        if (j === 'division') {
          data = v.division.division
        }

        if (j === 'unit') {
          data = v.unit
        }

        if (j === 'quartal') {
          data = v.quartal
        }

        if (j === 'year') {
          data = v.year
        }

        if (j === 'sales') {
          data = v.sales_year
        }

        if (j === 'market') {
          data = v.ci.replace(/(<([^>]+)>)/gi, "")
        }

        if (j === 'proposed') {
          data = v.solution.replace(/(<([^>]+)>)/gi, "")
        }

        if (j === 'notes') {
          data = v.notes.replace(/(<([^>]+)>)/gi, "")
        }

        return data
      }))
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
